import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Form, Input, Row, Col, Button, Select, Table } from 'antd';
import util from '../../../util/index';
const {
  getParams,
} = util;
const FormItem = Form.Item;
const createForm = Form.create;
const Option = Select.Option;

@inject('sysStore')
@observer
class Main extends React.Component {
  static defaultProps = {
    formPrefixCls: 'sys-basic',
    prefixCls: 'sys-user',
  }
  componentDidMount() {
    this.reset();
  }
  reset = () => {
    const { form, sysStore: { init, getJoinList } } = this.props;
    form.resetFields();
    init();
    getJoinList();
  }
  onSubmit = () => {
    const { sysStore: { init, getJoinList }, form } = this.props;
    init(false);
    const params = getParams(form.getFieldsValue());
    getJoinList(params);
  }
  changeJoin = (jl_id, contacted) => {
    const { sysStore: { editJoinList } } = this.props;
    editJoinList({ jl_id, contacted }).then(() => {
      this.reset();
    });
  }
  getColumns = () => {
    const { prefixCls } = this.props;
    return [
      { title: '公司', dataIndex: 'companyname', key: 'companyname', },
      { title: '姓名', dataIndex: 'name', key: 'name', },
      { title: '邮箱', dataIndex: 'mail', key: 'mail', },
      { title: '手机', dataIndex: 'tel', key: 'tel', },
      { title: '是否联系', dataIndex: 'contacted', key: 'contacted', },
      {
        title: '操作', dataIndex: 'jl_id', key: 'jl_id', render: (text, record) => {
          return (
            <div className={`${prefixCls}-joinList-btn`}>
              <span onClick={() => this.changeJoin(text, 1)}>已联系</span>
              <span onClick={() => this.changeJoin(text, 0)}>未联系</span>
            </div>
          );
        },
      },
    ];
  }
  onTableChange = (current, pageSize) => {
    const { sysStore: { getSysPersons, setMobxState }, form } = this.props;
    setMobxState({ current, pageSize });
    const params = getParams(form.getFieldsValue());
    getSysPersons({ ...params, current, pageSize });
  }
  render() {
    const { prefixCls, formPrefixCls, form, sysStore: { joinList, joinCount, loading, pageSize, current } } = this.props;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const { getFieldProps } = form;
    return (
      <div className={`${formPrefixCls} ${prefixCls}`}>
        <div className={`${prefixCls}-header`}>
          <Form>
            <Row>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="公司：" {...formItemLayout}>
                  <Input placeholder="请输入公司" {...getFieldProps('companyname')}/>
                </FormItem>
              </Col>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="姓名：" {...formItemLayout}>
                  <Input placeholder="请输入姓名" {...getFieldProps('name')} />
                </FormItem>
              </Col>
              <Col span={8} className={`${formPrefixCls}-row ${prefixCls}-row-btn`}>
                <Button type="primary" onClick={this.onSubmit}>搜索</Button>
                <Button onClick={this.reset}>重置</Button>
              </Col>
            </Row>
            <Row>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="邮箱：" {...formItemLayout}>
                  <Input placeholder="请输入邮箱" {...getFieldProps('mail')} />
                </FormItem>
              </Col>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="手机：" {...formItemLayout}>
                  <Input placeholder="请输入手机" {...getFieldProps('tel')} />
                </FormItem>
              </Col>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="是否联系：" {...formItemLayout}>
                  <Select {...getFieldProps('contacted', {
                    initialValue: 'all'
                  })}>              
                    <Option value="all">全部</Option>
                    <Option value="1">是</Option>
                    <Option value="0">否</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </div>
        <Table
          rowKey="jl_id"
          loading={loading}
          dataSource={toJS(joinList)}
          columns={this.getColumns()}
          pagination={{
            total: joinCount,
            pageSize: pageSize,
            current: current,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: total => (<span>共{total}条</span>),
            onChange: this.onTableChange,
            onShowSizeChange: (page, size) => this.onTableChange(1, size),
          }} />
      </div>
    )
  }
}

Main = createForm()(Main);
export default Main;


// WEBPACK FOOTER //
// ./src/components/sys/user/JoinList.js